import { z } from "zod";
import { tokenAliasOrValue } from "./base";

export const FontValue = z.unknown();

export const FontTokenData = tokenAliasOrValue(FontValue);

export type FontValue = z.infer<typeof FontValue>;
export type FontTokenData = z.infer<typeof FontTokenData>;
